

import GaugeChart from "@/components/shared/GaugeChart";

export default {
    name: 'FearAndGreedIndex',

    components: {
        GaugeChart,
    },

    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        isHomeScreen: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        getIndexText(score) {
            if (score < 20) {
                return this.$t('component.fearAndGreedIndex.extremeFear')
            } else if (score < 40) {
                return this.$t('component.fearAndGreedIndex.fear')
            } else if (score < 60) {
                return this.$t('component.fearAndGreedIndex.neutral')
            } else if (score < 80) {
                return this.$t('component.fearAndGreedIndex.greed')
            } else {
                return this.$t('component.fearAndGreedIndex.extremeGreed')
            }
        },
        getColorClass(score) {
            if (score < 20) {
                return 'red-500';
            } else if (score < 40) {
                return 'red-300'
            } else if (score < 60) {
                return 'purple-500'
            } else if (score < 80) {
                return 'blue-300'
            } else {
                return 'blue-500';
            }
        },
        getBgColorClass(score) {
            if (score < 20) {
                return 'bg-red-500';
            } else if (score < 40) {
                return 'bg-red-300'
            } else if (score < 60) {
                return 'bg-purple-500'
            } else if (score < 80) {
                return 'bg-blue-300'
            } else {
                return 'bg-blue-500';
            }
        },
    },
}
